module.exports = __webpack_public_path__ + "static/img/net-border-5.feabc14f.png";